import { render, staticRenderFns } from "./DeathReasonStatisticsChart.vue?vue&type=template&id=4ed5033b&scoped=true"
import script from "./DeathReasonStatisticsChart.vue?vue&type=script&lang=js"
export * from "./DeathReasonStatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./DeathReasonStatisticsChart.vue?vue&type=style&index=0&id=4ed5033b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5033b",
  null
  
)

export default component.exports